var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form-group',{attrs:{"label":_vm.title}},[_c('p',{staticClass:"rounded border p-1 mr-2 d-flex align-items-center",attrs:{"type":"text"}},[_vm._v(" "+_vm._s(_vm.data)+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }